<template>
  <div class="screenData">
    <img src="@/assets/logo.png" style="object-fit: cover;" width="100%" height="200px" alt="">
    <div align='right'>
      <div class="balance-container mt-4 mb-4">
        <div>
          ยอดเงิน: {{ profile.wallet }} ฿
        </div>
        <hr>
        <div style="color: red;">
          โบนัส: {{ profile.bonus }} ฿
        </div>
      </div>
    </div>
    <!-- 🔥 Fixed Header with Logo -->
    <!-- <header class="header">
      แทงดี888
      <img src="./assets/logo.png" alt="Logo">
    </header> -->

    <!-- 🔥 Main Content (for scrolling) -->
    <div class="content">
      <div style="margin-bottom: 0px;">
        <router-view />
      </div>
    </div>

    <!-- 🔥 Bottom Navigation -->
    <div>
      <nav class="bottom-nav">
        <router-link style="text-decoration: none" :to="`/home`">
          <div id="home" class="nav-link" @click="setActive()">
            <i class="bi bi-house-door-fill"></i><br>หน้าแรก
          </div>
        </router-link>

        <router-link style="text-decoration: none" :to="`/bet`">
          <div id="bet" class="nav-link" @click="login()">
            <i class="bi bi-credit-card"></i><br>แทงหวย
          </div>
        </router-link>

        <router-link style="text-decoration: none" :to="`/topup`">
          <div id="topup" class="nav-link" @click="login()">
            <i class="bi bi-coin"></i><br>เติมเงิน
          </div>
        </router-link>

        <router-link style="text-decoration: none" :to="`/profile`">
          <div id="profile" class="nav-link" @click="login()">
            <i class="bi bi-person-circle"></i><br>สมาชิก
          </div>
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import './assets/style.css'
import authentication from './middleware/authentication';
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      profile: state => state.profile
    })
  },
  mounted() {
    this.getProfile();
    this.getData();
  },
  watch: {
    '$route.path'(newPath) {
      document.getElementById('home').style.color = '#2F5558'
      document.getElementById('bet').style.color = '#2F5558'
      document.getElementById('topup').style.color = '#2F5558'
      document.getElementById('profile').style.color = '#2F5558'

      // if (newPath != '/') {
      //   try {
      //     axios.get(`${process.env.VUE_APP_SERVER}/user/auth/profile`, authentication.getHeaderAuthen()).then(response => {
      //       if (response.status == 401) {
      //         localStorage.removeItem('auth');
      //         window.location.href = `${process.env.VUE_APP_SERVER}/user/auth/login-line`
      //       }
      //     })
      //   } catch (error) {
      //     console.log('catch')
      //     localStorage.removeItem('auth');
      //     window.location.href = `${process.env.VUE_APP_SERVER}/user/auth/login-line`
      //   }
      // }

      if (newPath == '/' || newPath == '/home') {
        document.getElementById('home').style.color = 'white'
      } else if (newPath == '/bet') {
        document.getElementById('bet').style.color = 'white'
      } else if (newPath == '/topup') {
        document.getElementById('topup').style.color = 'white'
      } else if (newPath == '/profile') {
        document.getElementById('profile').style.color = 'white'
      }
    }
  },
  methods: {
    async getProfile() {
      await axios.get(`${process.env.VUE_APP_SERVER}/user/auth/profile`, authentication.getHeaderAuthen()).then(response => {
        if (response.data.success) {
          this.wallet = response.data.obj.wallet
        }
      })
    },
    async getData() {
      const getPath = window.location.pathname;

      if (getPath == '/' || getPath == '/home') {
        document.getElementById("home").style.color = 'white';
      }

      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      const refresh = urlParams.get('refresh');

      if (token != null && token != undefined && refresh != null && refresh != undefined) {
        localStorage.setItem("auth", token);
        localStorage.setItem("refresh", refresh);
        window.location.href = '/'
      }

      // if (window.location.pathname != '/') {
      //   const token = localStorage.getItem("auth");
      //   if (token == null || token == undefined) {
      //     window.location.href = `${process.env.VUE_APP_SERVER}/user/auth/login-line`
      //   }
      // }

    },
    async login() {
      // const token = localStorage.getItem("auth");

      // if (token == null || token == undefined) {
      //   window.location.href = `${process.env.VUE_APP_SERVER}/user/auth/login-line`
      // }
    },
    setActive() {
      const token = localStorage.getItem("auth");
      if (token != null && token != undefined) {
        window.location.href = '/home'
      } else {
        window.location.href = '/'
      }
    }
  },
  data: () => ({
    wallet: 0,
    // stripe: '',
  }),
}
</script>

<style scoped>
/* Fixed Logo Header */
.header {
  position: fixed;
  top: 0;
  width: 100%;
  background: white;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  z-index: 1000;
}

.header img {
  height: 40px;
}

* {
  font-family: 'Sarabun', sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Body Padding (to avoid content being hidden under header) */
body {
  font-family: 'Sarabun', sans-serif;
  padding-top: 70px;
  padding-bottom: 80px;
}

/* Bottom Navigation Bar */
.bottom-nav {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 95%;
  background: #d9c68f;
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-around;
  padding: 5px;
  /* margin-left: 5px; */
  /* margin-right: 5px; */
  z-index: 1000;
}

.bottom-nav a {
  text-align: center;
  text-decoration: none;
  color: black;
  font-size: 14px;
  transition: all 0.3s ease-in-out;
}

.bottom-nav a i {
  font-size: 24px;
  transition: transform 0.2s ease-in-out;
}

.bottom-nav a.active i {
  color: blue;
  transform: scale(1.3);
}

.nav-link:active {
  color: #2F5558;
}

@media only screen and (min-width: 768px) {
  .screenData {
    padding-left: 20%;
    padding-right: 20%;
  }

  .bottom-nav {
    width: 60%;
  }
}

.balance-container {
  /* display: inline-flex; 
    justify-content: flex-end; 
    align-items: center; 
    font-size: 24px;
    font-weight: bold;
    color: green;
    background-color: #f0f8f0;
    padding: 10px;
    border-radius: 10px;
    width: max-content; 
    text-align: right; */
  font-size: 20px;
  font-weight: bold;
  font-weight: bold;
  color: green;
  width: max-content;
  padding: 10px;
  border-radius: 10px;
  background-color: #f0f8f0;
  margin-right: 20px;
}
</style>
